import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Alert, Button, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { payrollAPI } from '../../services/api';
import { PageHeader, Section } from './payrollUi';
import { statuteLabel } from './plainLabels';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function money(value) {
  if (value == null || value === '') return 'Not ready';
  return `₹${Number(value).toLocaleString('en-IN')}`;
}

export default function PayslipPage() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [requested, setRequested] = useState(false);
  const [kind, setKind] = useState('month');
  const slip = useQuery(
    ['my-payslip', year, month, kind, requested],
    async () => (await payrollAPI.myPayslip(year, month, kind)).data.data,
    { enabled: requested, retry: false }
  );
  const data = slip.data;
  const title = data?.payee_type === 'contractor' ? 'Fee voucher' : 'Payslip';

  return (
    <Stack spacing={2}>
      <PageHeader
        title="My payslip"
        subtitle="Choose the month and press Show. The slip is ready after Payroll has been processed."
      />
      <Section title="Which slip">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
          <TextField select size="small" label="Month" value={month} onChange={(e) => { setMonth(Number(e.target.value)); setRequested(false); }} sx={{ minWidth: 160 }}>
            {MONTHS.map((name, index) => <MenuItem key={name} value={index + 1}>{name}</MenuItem>)}
          </TextField>
          <TextField size="small" label="Year" type="number" value={year} onChange={(e) => { setYear(Number(e.target.value)); setRequested(false); }} sx={{ width: 120 }} />
          <TextField select size="small" label="Which pay" value={kind} onChange={(e) => { setKind(e.target.value); setRequested(false); }} sx={{ minWidth: 200 }}>
            <MenuItem value="month">Regular month</MenuItem>
            <MenuItem value="exit">Final settlement</MenuItem>
          </TextField>
          <Button variant="contained" onClick={() => setRequested(true)}>Show</Button>
        </Stack>
      </Section>
      {slip.isError && <Alert severity="info">That slip is not ready yet. It appears after the month is processed.</Alert>}
      {data && (
        <Section title={`${title} · ${data.display_name}`} hint={`${MONTHS[month - 1]} ${year}`}>
          <Stack spacing={1}>
            <Typography>Pay before deductions: {money(data.gross)}</Typography>
            <Typography>Taken from pay: {money(data.employee_deductions)}</Typography>
            <Typography variant="h6">You receive: {money(data.net)}</Typography>
            <Typography variant="body2" color="text.secondary">
              Provident fund, ESI, labour welfare fund, and gratuity paid by Bacchapanti are {money(data.employer_cost)}. They are not taken from what you receive.
            </Typography>
            {(data.lines || []).map((line) => (
              <Typography key={line.id} variant="body2">{line.line_name}: {money(line.paid_amount)}</Typography>
            ))}
            {(data.incentives || []).map((item) => (
              <Typography key={item.id} variant="body2">{item.code}: {money(item.amount)}</Typography>
            ))}
            {(data.statutes || []).map((item) => (
              <Typography key={item.id} variant="body2">
                {statuteLabel(item.statute_code)}: from you {money(item.employee_amount)} · from Bacchapanti {money(item.employer_amount)}
              </Typography>
            ))}
          </Stack>
        </Section>
      )}
    </Stack>
  );
}
